import {
  accountantMenuSections as baseAccountantMenuSections,
  superadminMenuSections as baseSuperadminMenuSections,
  companyManagerMenuSections as baseCompanyManagerMenuSections,
  userMenuSections,
  operatorMenuSections,
  coordinatorMenuSections,
  servicemanMenuSections,
  Menu,
  TopMenu,
  SectionMenuPopup,
} from '@/pages/dashboard/menu/menus';
import { isNFCSupported } from '../../tools/nfc/accwriter';

export {
  userMenuSections,
  operatorMenuSections,
  coordinatorMenuSections,
  servicemanMenuSections,
  Menu,
  TopMenu,
  SectionMenuPopup,
};
const remanentManagementItems = [
  { url: '/communal/remanent/locations/manager', name: 'menu.locations' },
  { url: '/communal/remanent/inventory-groups/manager', name: 'menu.inventory_groups' },
  { url: '/communal/remanent/inventory-items/manager', name: 'menu.inventory_items' },
];

export const superadminMenuSections: typeof baseSuperadminMenuSections = (props) => {
  const sections = baseSuperadminMenuSections(props);

  return sections.map((section) => {
    if (section.group === 'special') {
      return {
        ...section,
        items: [
          ...(section.items ?? []),
          ...(isNFCSupported() ? [{ url: '/tool/nfc/accountantwriter', name: 'menu.nfcwriter' }] : []),
        ],
      };
    }

    if (section.group === 'management') {
      return {
        ...section,
        items: [
          ...(section.items ?? []),
          ...remanentManagementItems,
        ],
      };
    }

    return section;
  });
};

export const companyManagerMenuSections: typeof baseCompanyManagerMenuSections = (props) => {
  const sections = baseCompanyManagerMenuSections(props);

  return sections.map((section) => {
    if (section.group === 'management') {
      return {
        ...section,
        items: [
          ...(section.items ?? []),
          ...remanentManagementItems,
        ],
      };
    }

    return section;
  });
};

export const accountantMenuSections: typeof baseAccountantMenuSections = (props) => {
  const sections = baseAccountantMenuSections(props);

  return sections.map((section) => {
    if (section.group === 'special') {
      return {
        ...section,
        items: [
          ...(section.items ?? []),
          ...(isNFCSupported() ? [{ url: '/tool/nfc/accountantwriter', name: 'menu.nfcwriter' }] : []),
        ],
      };
    }

    if (section.group === 'management') {
      return {
        ...section,
        items: [
          ...(section.items ?? []),
          ...remanentManagementItems,
        ],
      };
    }

    return section;
  });
};